import React, { useEffect, useState } from "react";
import { Button, Card, Form, Image } from "react-bootstrap";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import TechniciansService from "../../../../services/technician.service";
import JobTypeService from "../../../../services/jobtype.service";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import TechnicianPlansService from "../../../../services/technicianplan.service";
import CustomersService from "../../../../services/customer.service";
import TableForm2s from "../../../../components/TableFormScrb";
import { formatDate } from "../../../../commons/FormatValue";
import ConfirmModal from "../../../../components/ConfirmModal";
import { useLocation, useNavigate } from "react-router-dom";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import PropTypes from "prop-types";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import DepartJobsService from "../../../../services/departjob.service";

function PlanningForm({ initialData }) {
  const navigate = useNavigate();

  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [seqNo, setSeqNo] = useState([]);
  const [CustomerName, setCustomerName] = useState([]);
  const [CustomerCode, setCustomerCode] = useState([]);
  const [data, setData] = useState([]);
  const [bodyReq, setBodyReq] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusMas, setStatusMas] = useState([]);
  const [validated, setValidated] = useState(false)

  const getData = () => {
    // getServiceRequest({
    //   showAlert,
    //   setLoading: () => {},
    //   serviceRequest: TechniciansService.getAllTechnicians(),
    //   callback: (res) => {
    //     setTechnicians(res);
    //   }
    // });

    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechnicianPlansService.getTechnicianPlansFindJobs(
        getQueryString({
          page: 1,
          limit: 15,
          jobStatus: "OPEN"
        })
      ),
      callback: (res) => {
        const all = []
        res.map(el => {
          if (el.Seq_Oth_No) all.push({ Seq_no: el.Seq_Oth_No })
          if (el.seq_install_no) all.push({ Seq_no: el.seq_install_no })
          if (el.seq_repair_no) all.push({ Seq_no: el.seq_repair_no })

        })
        setSeqNo(all.sort((a, b) => a.Seq_no?.localeCompare(b.Seq_no)))
        // const seq_oth_no = res
        //   ?.filter((item) => {
        //     return item?.Seq_Oth_No;
        //   })
        //   .map((r) => {
        //     return {
        //       Seq_no: r?.Seq_Oth_No
        //     };
        //   });
        // const seq_install_no = res
        //   ?.filter((item) => {
        //     return item?.seq_install_no;
        //   })
        //   .map((r) => {
        //     return {
        //       Seq_no: r?.seq_install_no
        //     };
        //   });
        // setSeqNo([...seq_oth_no, ...seq_install_no]);
      }
    });
  };

  useEffect(() => {
    setJobTypes(initialData.jobTypes)
    setTechnicians(initialData.technicians)
    getData();
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: DepartJobsService.getAllDepartJobs(),
      callback: (res) => setStatusMas(res)
    });
  }, []);
  const searchInput = [
    {
      name: "start",
      label: "จากวันที่่ออกใบสั่งงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3
    },
    {
      name: "end",
      label: "ถึงวันที่่ออกใบสั่งงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      min: 'start'
    },
    {
      name: "jobTypeId",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: jobTypes
      })
    },
    {
      name: "searchJobNo",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Seq_no",
        label: "Seq_no",
        dataset: seqNo
      })
    },
    {
      name: "Technician",
      disabled: true,
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      size: 3,
      // required: true,
      noneAsync: true,
      filterBy: ["Tech_Mas_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Tech_Mas_Name",
        dataset: technicians
      })
    },
    {
      name: "cusCode",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      filterBy: ["Cus_Code"],
      options: initializeSetOption({
        key: "Cus_Code",
        label: "Cus_Code",
        dataset: CustomerCode
      }),
      size: 3,
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerCode(items)
        });
      }
    },
    {
      name: "cusName",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 6,
      filterBy: ["Cus_Name"],
      options: initializeSetOption({
        key: "Cus_Name",
        label: "Cus_Name",
        dataset: CustomerName
      }),
      // noneAsync: true,
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerName(items)
        });
      }
    }
  ];

  const handleSearchCallback = (search) => {
    if (search) {
      setCurrentPage(1)
      getTechnicianPlansBy({
        ...search,
        start: toFormatISO(search?.start),
        end: toFormatISO(search?.end),
        jobStatus: "OPEN",
        page: 1,
        limit: rowsPerPage
      });
    } else {
      setData([])
      setBodyReq([])
    }
  };

  const getTechnicianPlansBy = (query) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.getTechnicianPlansFindJobs(
        getQueryString(query)
      ),
      callback: (res) => {
        setData(
          res?.map((item, index) => {
            return {
              Id: item?.Id || item?.id,
              "seq_pm_id": (item?.JobTypes?.Id || item?.JobType?.Id) == 5 ? item?.id : null,
              "seq_serv_id": item?.job_type_items?.Id == 2 ? item?.id : null,
              "seq_oth_id": item?.Id || null,
              seq_inst_id: item?.JobTypes?.Id == 1 ? item?.id : null,
              seq_status_id: item?.seq_status_id || initialData?.seqStatus.find(el => el.Seq_St_Name == "In Process"),
              depart_st_id: null,

              JobType:
                item?.JobType?.Job_Type_Name ||
                item?.JobTypes?.Job_Type_Name ||
                item?.job_type_items?.Job_Type_Name,
              // JobType: item?.JobType?.Id // อื่นๆ
              //   || item?.JobTypes?.Id  // ติดตั้ง 1
              //   || item?.job_type_items?.Id, // แจ้งซ่อม 2
              Seq_No:
                item?.Seq_Oth_No || item?.seq_install_no || item?.seq_repair_no,
              Cus_Code:
                item?.InformOtherJob?.Customer?.Cus_Code ||
                item?.InformInstallJobs?.Customer?.Cus_Code ||
                item?.inform_repair_items?.concern_customer_items?.Cus_Code,
              Cus_Name:
                item?.InformOtherJob?.Customer?.Cus_Name ||
                item?.InformInstallJobs?.Customer?.Cus_Name ||
                item?.inform_repair_items?.concern_customer_items?.Cus_Name,
              Job_Cus_Date: item?.InformInstallJobs?.Job_Cus_Date,
              Job_Start_Date: formatInputDate(item.job_start_date, "Local").date,
              Job_End_Date: formatInputDate(item?.job_end_date, "Local").date,
              Job_Actual_Date: formatInputDate(new Date(), "Local").date,
              plan_status: item?.SequneceStatus?.Seq_St_Name,
              Seq_St_Name: "In Process", //item?.SequneceStatus?.Seq_St_Name,
              tech_mas_id: null
            };
          })
        );
      }
    });
  };

  const handleChangeRow = (newData, isSet) => {
    if (isSet) setData(newData)
    setBodyReq(
      newData
        // ?.filter((item) => item.tech_mas_id)
        ?.filter((item) => item.isChecked)
        .map((item) => {
          return {
            tech_mas_id: item.tech_mas_id,
            "seq_pm_id": item.seq_pm_id,
            "seq_inst_id": item.seq_inst_id,
            "seq_oth_id": item.seq_oth_id,
            "seq_serv_id": item.seq_serv_id,
            plan_status: "PLANNED",
            "seq_status_id": item.seq_status_id,
            "depart_st_id": (item.depart_st_id),
            // "tech_mas_name": "",
            "tech_doc_date": formatDate(new Date(), "YYYY-MM-DD"),
            "job_actual_date": item.Job_Actual_Date
          }

          // const filteredItem = {};
          // Object.entries(item).forEach(([key, value]) => {
          //   if (key !== "isEdit" && !key.match(/^[A-Z]/)) {
          //   filteredItem[key] = value;
          //   }
          // });
          // return filteredItem;
        })
    );
  };

  const columns = [
    {
      name: "JobType",
      label: "ประเภทงาน",
      readOnly: true,
      // format: (row) => JobType.find(item => item.Id === row.Job_Type_Id)?.Job_Type_Name,
      width: "180px"
    },
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      width: "250px",
      showTooltip: true,
    },
    // {
    //   name: "",
    //   label: "รายละเอียดสินค้า",
    //   width: "200px",
    //   readOnly: true
    // },

    {
      name: "Job_Start_Date",
      label: "วันที่เข้างานระหว่าง",
      readOnly: true,
      width: "185px",
      format: (row) => formatDate(row.Job_Start_Date)
    },
    {
      name: "Job_End_Date",
      label: "ถึงวันที่",
      readOnly: true,
      format: (row) => formatDate(row.Job_End_Date)
    },
    {
      name: "Job_Actual_Date",
      label: "วันที่เข้างานจริง",
      width: "180px",
      type: "date"
    },
    {
      name: "tech_mas_id",
      label: "ช่างผู้ปฏิบัติงาน",
      type: "select",
      required: true,
      noneAsync: true,
      options: initializeSetOption({
        key: "Id",
        label: "Tech_Mas_Name",
        dataset: technicians
      }),
      width: "220px"
    },
    {
      name: "depart_st_id",
      label: "สถานะงานช่าง",
      type: "select",
      required: true,
      noneAsync: true,
      options: initializeSetOption({
        key: "Id",
        label: "Depart_St_Name",
        dataset: statusMas
      }),
    },
    {
      name: "Seq_St_Name",
      label: "สถานะใบสั่งงาน",
      readOnly: true,
      width: "158px",
    },
    {
      name: "plan_status",
      label: "สถานะแผน",
      readOnly: true
    },
  ];

  const createTechniciansPlan = async (req) => {
    await TechnicianPlansService.createTechnicianPlans(req)
      .then(() => {
        getTechnicianPlansBy({
          jobStatus: "OPEN",
          page: 1,
          limit: rowsPerPage
        });
        showAlert({ error: "บันทึกสำเร็จ", type: "success" });
      })
      .catch(({ error, message }) => {
        setShowModal(false);
        showAlert({ error: message, type: "danger" });
      });
  };
  const onSubmit = async (event, obj) => {
    event.preventDefault();
    // console.log(obj?.dataCallback)
    setShowModal(false);

    if (obj && obj?.dataCallback) {
      await createTechniciansPlan({ Array: obj?.dataCallback });
    }
  };

  const handleValidated = (event) => {
    event.preventDefault();
    // const form = event.currentTarget;
    // if (!form.checkValidity()) {
    const fillTech = bodyReq?.length && bodyReq.every(d => d.tech_mas_id && d.depart_st_id)
    console.log(fillTech,bodyReq)
    if (!fillTech) {
      event.stopPropagation();
      setValidated(true);
    } else {
        setShowModal(true);
    }
  }
  return (
    <div>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body>
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchCallback={handleSearchCallback}
          />
        </Card.Body>
      </Card>

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2">รายละเอียดงาน</Card.Title>
        </Card.Header>

        <Form noValidate onSubmit={handleValidated}>
          <Card.Body>

            <TableForm2s
              data={data.slice(rowsPerPage * (currentPage - 1), currentPage * rowsPerPage)}
              allData={data}
              columns={columns}
              editForm={true}
              showDeleteButton
              hideMoreButton
              isLoading={loading}
              onChangeCallback={handleChangeRow}
              // component="planningForm"
              sorting
              checkBoxShow={true}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              rowCount={data.length}
              fetchData={pag => {
                setCurrentPage(pag.page)
                if (pag.limit) setRowsPerPage(pag.limit)
              }}
              validated={validated}
            />
          </Card.Body>
          {!!data.length &&
            <Card.Body className="text-end">
              <Button
                type="submit"
                variant="success"
                className="px-5 py-2 text-dark rounded-pill"
              >
                บันทึกข้อมูล
              </Button>
              <ConfirmModal
                show={showModal}
                data={bodyReq}
                content="save"
                onSubmitCallback={onSubmit}
              />
            </Card.Body>
          }
        </Form>
      </Card>
    </div>
  );
}

PlanningForm.propTypes = {
  initialData: PropTypes.object
};
export default PlanningForm;
